<script>
export default {
  data() {
    return {
      isShow: false,
      yVisibleOffset: 100,
    }
  },
  computed: {
    isVisible() {
      return !this.$route.meta?.hideMobileUpArrow
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.isShow = window.scrollY > this.yVisibleOffset
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
  },
}
</script>

<template
  ><div class="d-contents">
    <Transition name="fade">
      <div v-show="isShow && isVisible" :class="$style.scrollTopArrow" @click="scrollToTop" />
    </Transition>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.scrollTopArrow {
  @media (max-width: $lg-breakpoint) {
    bottom: 100px;
  }

  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 999;
  width: 64px;
  height: 64px;
  cursor: pointer;
  background: white url(~@assets/icons/ArrowGray.svg) no-repeat center;
  border: 1px solid $light-gray;
  border-radius: 50%;
  box-shadow: 3px -3px 6px rgba(196, 196, 196, 0.3);
  transition: all 0.3s ease-in-out;
  transform: rotate(90deg);
  transform-origin: center center;

  &:hover {
    transform: rotate(90deg) scale(1.05);
  }
}
</style>
